import React from 'react';
import sentGAEvent from '@/ga';
import { Image, Button } from 'antd';
import { ReactComponent as CloseIcon } from '@/assets/icons/close.svg';
import { useTranslation } from 'react-i18next';

import '@/assets/toGIF.less';
import Utils from '@/utils';

const ToGIFWorkSuccessRender = ({ fileListModal, onFileListModalChange }) => {
  const { t } = useTranslation(['toGIF']);

  return (
    fileListModal &&
    fileListModal.show && (
      <div className='success'>
        <CloseIcon
          className='close-file'
          onClick={() => onFileListModalChange(null)}
        />
        <div className='lft'>
          <Image src={fileListModal.newObj.videofileurl} preview={false} />
          <div className='info'>
            <span>{fileListModal.newObj.duration}</span>
            <span>
              {(fileListModal.newObj.size / 1024 / 1024).toFixed(2)}MB
            </span>
          </div>
        </div>
        <div className='rgt'>
          <Button
            size='large'
            type='primary'
            onClick={() => {
              Utils.downloadFile(fileListModal.newObj, 'gif');
              sentGAEvent({
                category: 'DownloadStart',
                action: '37TG_DownloadStart',
              });
            }}
          >
            {t('Download GIF')}
          </Button>
          <Button
            size='large'
            type='primary'
            ghost
            onClick={() => {
              sentGAEvent({
                category: 'ToGif',
                action: 'GifNew',
              });
              window.open(window.location.href);
            }}
          >
            {t('Create A New One')}
          </Button>
          <Button
            size='large'
            type='primary'
            ghost
            onClick={() => {
              sentGAEvent({
                category: 'ToGif',
                action: 'GifBackEdit',
              });
              onFileListModalChange(null);
            }}
          >
            {t('Remake GIF')}
          </Button>
        </div>
      </div>
    )
  );
};

export default ToGIFWorkSuccessRender;
